<template>
  <v-flex
     xs12
    align-self-center
    justify-center
  >
  <div>
    <v-container fill-height fluid>
    <v-row>
      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_from"
          :label="$t('fields.date_from')"
          :clearable="true"
        />
      </v-flex>

      <v-flex xs2 class="ml-2">
        <InputDataPicker
          v-model="filters.date_to"
          :label="$t('fields.date_to')"
          :clearable="true"
        />
      </v-flex>
      <v-flex xs2 class="mt-6 ml-2">
        <PropagandistSelect
          v-model="filters.propagandist_id"
          :label="$t('fields.propagandist')"
        />
      </v-flex>
      <v-spacer></v-spacer>
        <v-btn
          @click="exportData()"
          dark
        >{{ $t("EXPORT") }}
        </v-btn>

    </v-row>
    </v-container>

    <v-row>
      <v-col
        cols="12"
      >
      <ul>
        <li v-for="propagandist in propagandists" :key="propagandist.propagandist_id">
          {{ propagandist.propagandist }} ({{ propagandist.book_counter }})
        </li>
      </ul>
      </v-col>
    </v-row>
    <v-row>
    <v-col
      cols="12"
    >

    <v-data-table
      :headers="headers"
      :items="items"
      :server-items-length="totalItems"
      :no-data-text="$t('NO_DATA')"
      :no-results-text="$t('NO_DATA')"
      hide-default-footer
      :options.sync="pagination"
      :loading="loading"
      class="elevation-1"
    >

      <template v-slot:[`item.title`]="{ item }">
            {{ item.book.title }}
      </template>

      <template v-slot:[`item.isbn`]="{ item }">
            {{ item.book.isbn }}
      </template>

      <template v-slot:[`item.author`]="{ item }">
            {{ item.book.author }}
      </template>

      <template v-slot:[`item.volume`]="{ item }">
            {{ item.book.volume }}
      </template>

      <template v-slot:[`item.propagandist`]="{ item }">
            {{ item.propagandist.fullname }}
      </template>

      <template v-slot:[`item.book_counter`]="{ item }">
            {{ item.counters.book_counter }}
      </template>

      <template v-slot:[`item.editor`]="{ item }">
            {{ item.editor.name }}
      </template>


    </v-data-table>
    <Paginator
      :total-items="totalItems"
      :page.sync="pagination.page"
      :items-per-page.sync="pagination.itemsPerPage"
      @change="fetchCampaigns"
    />
    </v-col>
    </v-row>
  </div>
  </v-flex>
</template>
<script>

  import { mapActions } from 'vuex';

  import { campaignsReportService } from '../../../utils/services/campaignsReport.service';

  import InputDataPicker from '../../../components/shared/Inputs/InputDataPicker.vue';
  import PropagandistSelect from '../../../components/shared/Vselects/PropagandistSelect.vue';
  import Paginator from '../../../components/shared/Paginator';

  export default {
    name: 'CampaignReportSample',
    components: {
      InputDataPicker,
      PropagandistSelect,
      Paginator,
    },
    data() {
      return {
        loading: false,
        items: [],
        propagandists: [],
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [false],
          sortBy: ['title'],
        },

        headers: [
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume' },
          { text: this.$t('fields.editor'), value: 'editor' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.quantity'), value: 'book_counter', sortable: false },
          { text: this.$t('fields.propagandist'), value: 'propagandist' },
        ],
        filters: {
          date_from: null,
          date_to: null,
          propagandist_id: 0,
        },
      };
    },
    computed: {
      requestFilters() {
        const filters = {
          date_from: this.filters.date_from,
          date_to: this.filters.date_to,
          propagandist_id: this.filters.propagandist_id,
        };

        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },

    },
    methods: {
      ...mapActions('confirm', ['showConfirm']),
      ...mapActions('modal', ['showModal', 'hideModal']),
      ...mapActions('alert', ['showToast']),

      async fetchCampaigns(forcePage) {
        this.loading = true;
        const { page, itemsPerPage } = this.pagination;
        return campaignsReportService.propagandistReportBooked({
          page: forcePage || page || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.items = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      async fetchPropagandistReport() {
        return campaignsReportService.propagandistReportBookedTotal({
          filters: this.requestFilters,
        })
          .then(response => {
            this.propagandists = response.data.data;
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

      exportData() {
        this.loading = true;
        return campaignsReportService.propagandistReportBooked({
          filters: { ...this.requestFilters, export: true },
        })
          .then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'booked.csv');
            document.body.appendChild(link);
            link.click();
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loading = false;
          });
      },

    },
    async created() {
      await this.fetchCampaigns(1);
      await this.fetchPropagandistReport();
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchCampaigns(1);
          this.fetchPropagandistReport();
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchCampaigns(1);
          }
        },
      },

    },
  };
</script>
